import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Basic from '../Components/Basic/Basic'; 
import moment from 'moment'; 
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const Commodities = ({accountSlug:propAccountSlug}) => {
    const navigate = useNavigate(); 
    const systemToken = localStorage.getItem('systemToken') || "";
    const BASE_URL = process.env.REACT_APP_EXISTING_BASE_URL || 'https://api.caprock.com.au/';
    
    // State variables
    const [userName, setUserName] = useState('');
    const [userInfo, setUserInfo] = useState({});
    const [customerAccounts, setCustomerAccounts] = useState([]);
    const [totalAcBalance, setTotalAcBalance] = useState(0);
    const [totalActiveDefaultBalance, setTotalActiveDefaultBalance] = useState(0);
    const [totalArchiveDefaultBalance, setTotalArchiveDefaultBalance] = useState(0);
    const [defaultCurrencyIcon, setDefaultCurrencyIcon] = useState('$');
    const [defaultCurrency, setDefaultCurrency] = useState('AUD');
    const [subac, setSubac] = useState([
       
    ]);
    const [transactions, setTransactions] = useState([]);
    const [allTransactions, setAllTransactions] = useState([]);
    const [activeSubac, setActiveSubac] = useState(1);
    const [localStorageData, setLocalStorageData] = useState({}); // Renamed from localStorage
    const [activeTab, setActiveTab] = useState('transactions'); // New state for tab management
    const [fees, setFees] = useState([]); // New state for fees data
    const [commodity, setCommodity] = useState({
        ac_balance: 0,
        default_currency_balance: 0,
        userac_name: 'Commodities Management',
        userac_reference_code: '#',
        userac_establish_date: ''
    });
    const [allTradings, setAllTradings] = useState([]);
    const [timer, setTimer] = useState(undefined);
    
    // Chart state
    const [last12Months] = useState([
        moment().subtract(11, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(10, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(9, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(8, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(7, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(6, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(5, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(4, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(3, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(2, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(1, "month").startOf("month").format('MMM, YYYY'),
        moment().subtract(0, "month").startOf("month").format('MMM, YYYY'),
    ]);
    const [activeChart, setActiveChart] = useState(1);
    const [onChart, setOnChart] = useState(0);
    const [chart1, setChart1] = useState([0, 0, 0, 0]);
    const [chart2, setChart2] = useState([0, 0, 0]);
    const [chart3, setChart3] = useState([0, 0, 0, 0, 0, 0]);
    const [chart4, setChart4] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);
    const [chart5, setChart5] = useState([0, 0]);

    // Chart options
    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                backgroundColor: 'black',
                borderColor: 'black',
                borderWidth: 1,
                titleColor: '#fdad41',
                bodyColor: 'white',
                displayColors: false,
                callbacks: {
                    label: function(context) {
                        return `$${context.parsed.y.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                    }
                }
            }
        },
        scales: {
            x: {
                grid: {
                    display: false
                },
                ticks: {
                    color: '#fdad41',
                    font: {
                        size: 12
                    }
                }
            },
            y: {
                grid: {
                    color: 'rgba(0, 0, 0, 0.1)',
                    lineWidth: 1
                },
                ticks: {
                    display: false
                },
                border: {
                    display: false
                }
            }
        },
        elements: {
            line: {
                tension: 0.4
            },
            point: {
                radius: 0,
                hoverRadius: 6
            }
        }
    };


    const getAccountSlugFromStorage = () => {
        return window.localStorage.getItem('active_page') || 'commodities';
    };
    
    // Force crypto for this component - you can make this dynamic later
    const accountSlug = propAccountSlug || 'commodities';
    
    // Debug: log what accountSlug is being used
    // console.log('Current accountSlug:', accountSlug);


    const getAccountColors = (slug) => {
        const colorMap = {
          'paymaster': {
            gradient: 'bg-purple-gradient',
            tailwindGradient: 'from-purple-600 to-pink-200',
            bgClass: 'bg-purple-gradient',
            color: '#7957F5',
            colorName: 'purple',
            textColor: 'text-white',
            isDark: false
          },
          'fum': {
            gradient: 'bg-yellow-gradient', 
            tailwindGradient: 'from-orange-400 to-yellow-500',
            bgClass: 'bg-yellow-gradient',
            color: '#fdad41',
            colorName: 'orange',
            textColor: 'text-white',
            isDark: false
          },
          'securities': {
            gradient: 'bg-black-gradient',
            tailwindGradient: 'from-gray-600 to-gray-700',
            bgClass: 'bg-black-gradient',
            color: '#494949',
            colorName: 'black',
            textColor: 'text-white',
            isDark: true
          },
          'property': {
            gradient: 'bg-brown-gradient',
            tailwindGradient: 'from-amber-700 to-amber-800',
            bgClass: 'bg-brown-gradient',
            color: '#ad8e8e',
            colorName: 'brown',
            textColor: 'text-white',
            isDark: false
          },
          'commodities': {
            gradient: 'bg-blue-gradient',
            tailwindGradient: 'from-blue-400 to-blue-500',
            bgClass: 'bg-blue-gradient',
            color: '#33bfff',
            colorName: 'blue',
            textColor: 'text-white',
            isDark: false
          },
          'custodian': {
            gradient: 'bg-dark-gradient',
            tailwindGradient: 'from-gray-900 to-black',
            bgClass: 'bg-dark-gradient',
            color: '#0a0909',
            colorName: 'dark',
            textColor: 'text-white',
            isDark: true
          },
          'my-investment': {
            gradient: 'bg-green-gradient',
            tailwindGradient: 'from-green-500 to-green-400',
            bgClass: 'bg-green-gradient',
            color: '#22b931',
            colorName: 'green',
            textColor: 'text-white',
            isDark: false
          },
          'crypto': {
            gradient: 'bg-crypto',
            tailwindGradient: 'from-indigo-900 to-indigo-950',
            bgClass: 'bg-crypto',
            color: '#08003b',
            colorName: 'black',
            textColor: 'text-white',
            isDark: true
          },
          'private-wealth': {
            gradient: 'bg-crypto',
            tailwindGradient: 'from-indigo-900 to-indigo-950',
            bgClass: 'bg-crypto',
            color: '#08003b',
            colorName: 'black',
            textColor: 'text-white',
            isDark: true
          }
        };
        
        return colorMap[slug] || colorMap['commodities']; // Default to crypto colors
      };
      
      const accountColors = getAccountColors(accountSlug);

    // Chart data functions
    const getChartData = (data, labels) => ({
        labels: labels,
        datasets: [{
            label: 'Balance',
            data: data,
            borderColor: '#fdad41',
            backgroundColor: 'rgba(253, 173, 65, 0.1)',
            borderWidth: 2,
            fill: true
        }]
    });

    // Chart data
    const chartData1 = getChartData(chart1, ["Week 1", "Week 2", "Week 3", "Week 4"]);
    const chartData2 = getChartData(chart2, [
        moment().subtract(2, "month").startOf("month").format('MMM'),
        moment().subtract(1, "month").startOf("month").format('MMM'),
        moment().subtract(0, "month").startOf("month").format('MMM'),
    ]);
    const chartData3 = getChartData(chart3, [
        moment().subtract(5, "month").startOf("month").format('MMM'),
        moment().subtract(4, "month").startOf("month").format('MMM'),
        moment().subtract(3, "month").startOf("month").format('MMM'),
        moment().subtract(2, "month").startOf("month").format('MMM'),
        moment().subtract(1, "month").startOf("month").format('MMM'),
        moment().subtract(0, "month").startOf("month").format('MMM'),
    ]);
    const chartData4 = getChartData(chart4, last12Months);
    const chartData5 = getChartData(chart5, ["0000", "0000"]);

     
   
    const get_account_detail = async (ac_name) => {
        try {
            const BASE_URL = process.env.REACT_APP_EXISTING_BASE_URL || 'https://api.caprock.com.au/';
            const formData = new FormData(); 
            formData.append('user_token', systemToken); 
            formData.append('ac_name', ac_name || accountSlug);
            const response = await fetch(`${BASE_URL}/customer-account`, {
                method: 'POST',
                body: formData
            }); 
            if (response.ok) {
                const data = await response.json();
                // console.log('Account detail data:', data);
                if (data.success === 200) {
                    const fumData = data.ac_info;
                    fumData.userac_establish_date = moment(fumData.userac_establish_date).format('DD MMM, YYYY');
                    setCommodity(fumData); 
                    if (data.ac_data && data.ac_data.subaccounts && data.ac_data.subaccounts.length > 0) {
                        setSubac(data.ac_data.subaccounts); 
                    }
                    // Set active subaccount
                    const subII = window.localStorage.getItem('commodities_subac_id');
                    let subId = '';
                    if (subII && subII > 0) {
                        subId = subII;
                    } else {
                        subId = data.ac_data.subaccounts[data.ac_data.subaccounts.length - 1].subac_id;
                    }
                    setActiveSubac(subId); 
                    const chartInfo = data.chart_data;
                    if (data.chart_data.length > 0) {
                        setChart1(data.chart_data.last_month_chart);
                        setChart2(data.chart_data.three_month_chart);
                        setChart3(data.chart_data.six_month_chart);
                        setChart4(data.chart_data.year_chart.reverse());
                    }
                    
                    // Process all time chart
                    const allChart = chartInfo.all_chart;
                    // console.log('All chart is', chartInfo);
                    
                    const newChart5 = [];
                    const labels = [];
                    
                    if (chartInfo.length === 1) {
                        newChart5.push(0);
                        labels.push((allChart[0].year - 1));
                    }
                    
                    for (let i = 0; i < chartInfo.length; i++) {
                        newChart5.push(allChart[i].balance);
                        labels.push(allChart[i].year);
                    }
                    
                    setChart5(newChart5);
                    setOnChart(1);
                }
            } else {
                console.error('Account detail response not ok:', response.status, response.statusText);
                // Set default values if API fails
                setCommodity({
                    ac_balance: '',
                    default_currency_balance: '',
                    userac_name: '',
                    userac_reference_code: '-',
                    userac_establish_date: '-'
                });
                setSubac([
                     
                ]);
                setActiveSubac(1);
                setOnChart(1);
            }
        } catch (error) {
            console.error('Error fetching account detail:', error);
            console.log("Setting default values due to error");
            // Set default values if API fails
            setCommodity({
                ac_balance: 0,
                default_currency_balance: 0,
                userac_name: '-',
                userac_reference_code: '-',
                userac_establish_date: '-'
            });
            setSubac([
                
            ]);
            setActiveSubac(1);
            setOnChart(1);
        }
    };

 
   

    // Methods
    const openLink = (id) => {
        const link = document.getElementById("URL" + id).value;
        window.open(link, '_blank');
    };

    

    const getUserInfo = async () => {
        const BASE_URL = process.env.REACT_APP_EXISTING_BASE_URL || 'https://api.caprock.com.au/';
        const formData = new FormData();
        formData.append('user_token', systemToken);
        const response = await fetch(`${BASE_URL}/profile`, {
          method: 'POST', 
          body: formData
        });
        if (response.ok) {
            const data = await response.json();
            
            if (data.success === 200) {
              const userInf = data.profile;
              userInf.join_date = userInf.join_date ? moment(userInf.join_date).format('DD MMM, YYYY') : '';
              setUserInfo(userInf);
              setDefaultCurrency(userInf.default_currency);
              setDefaultCurrencyIcon(userInf.default_currency_icon);
            }
          } else {
            
            // Set default values if API fails
            setUserInfo({
              user_name: '',
              join_date: '',
              default_currency: 'AUD',
              default_currency_icon: '$'
            });
            setDefaultCurrency('AUD');
            setDefaultCurrencyIcon('$');
          }  
        // get_user_info(localStorageData['access-token']) // Updated reference
        //     .then(response => {
        //         if (typeof response.data !== 'undefined' && response.data.success == 200) {
        //             const userInf = response.data.profile;
        //             userInf.join_date = userInf.join_date ? moment(userInf.join_date).format('DD MMM YYYY ') : '';
        //             setUserInfo(userInf);
        //             setDefaultCurrency(userInf.default_currency);
        //             setDefaultCurrencyIcon(userInf.default_currency_icon);
        //         }
        //     }).catch(e => {
        //         console.log(e);
        //     });
    };

    const getAccountDetail = (acName) => {
      get_account_detail(acName);
    };

    // Effects
    useEffect(() => { 
        document.title = "Commodities Management || Caprock Merchant Platform";
        localStorage.setItem('active_page', 'commodities');
    }, [navigate]);

    useEffect(() => {
        // if (localStorageData['access-token']) { // Updated reference
            console.log("useEffect triggered - making API calls");
            setUserName(''); 
            getAccountDetail('commodities');
        // } else {
        //     console.log('No token found in localStorageData');
        // }
    }, [localStorageData]); // Updated dependency

    // Debug useEffect to monitor subac state
    useEffect(() => {
        console.log('Subac state changed:', subac); 
    }, [subac]);

    return (
        <>
            <Basic />
            

            <div className="w-full p-5 mr-80 box-border mt-5">
                <section className="w-full">
                {/* Top Row - Account Details & Transactions */}
                <div className="flex flex-wrap gap-4 mb-6 w-full">
                    {/* Top Left - Account Details */}
                    <div className="flex-1 min-w-0" style={{ maxWidth: '33.33%' }}>
                    <div className={`bg-gradient-to-br ${accountColors.tailwindGradient} rounded-lg p-4 text-white`} style={{ minHeight: '300px' }}>
                        <div className="flex flex-wrap -mx-4">
                        <div className="w-1/2 px-4">
                            <h5 className="text-white text-sm font-medium mt-1">
                            <b>Account Type</b>
                            </h5>
                            <h5 className="text-white text-xs mt-2">
                            {accountSlug.charAt(0).toUpperCase() + accountSlug.slice(1).replace('-', ' ')}
                            </h5>
                        </div>
                        <div className="w-1/2 px-4">
                            <h5 className="text-white text-sm font-medium mt-1">
                            <b>Balance</b>
                            </h5>
                            <h5 className="text-white text-xs mt-2">
                            {defaultCurrency} {defaultCurrencyIcon} {commodity.default_currency_balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </h5>
                        </div>
                        </div>
                        <div className="flex flex-wrap -mx-4 mt-3">
                        <div className="w-1/2 px-4">
                            <h5 className="text-white text-sm font-medium mt-1">
                            <b>Account Name</b>
                            </h5>
                            <h5 className="text-white text-xs mt-2">
                            {commodity.userac_name}
                            </h5>
                        </div>
                        <div className="w-1/2 px-4 overflow-y-auto" style={{ maxHeight: '125px' }}>
                            {subac.map((subac_item) => (
                            <h5 key={subac_item.subac_id} className="text-white text-xs mt-2">
                                {subac_item.subac_name}<br />
                                {subac_item.currency_name} {subac_item.currency_symbol}{subac_item.subac_currency_balance.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </h5>
                            ))}
                        </div>
                        </div>
                        <div className="flex flex-wrap -mx-4 mt-3">
                        <div className="w-1/2 px-4">
                            <h5 className="text-white text-sm font-medium mt-1">
                            <b>Account Reference</b>
                            </h5>
                            <h5 className="text-white text-xs mt-2">
                            #{commodity.userac_reference_code}
                            </h5>
                        </div>
                        <div className="w-1/2 px-4">
                            <h5 className="text-white text-sm font-medium mt-1">
                            <b>Date Account Established</b>
                            </h5>
                            <h5 className="text-white text-xs mt-2">
                            {commodity.userac_establish_date}
                            </h5>
                        </div>
                        </div>
                    </div>
                    </div>

                    {/* Top Right - Transactions & Fees */}
                    <div className="flex-1 min-w-0" style={{ maxWidth: '66.67%' }}>
                    <div className="bg-white rounded-lg shadow-lg" style={{ minHeight: '300px' }}>
                         
                        <div className="px-1 pl-3 py-3 border-b border-gray-200">
                            <div className="flex items-center justify-between">
                                <h3 className="text-base font-medium text-gray-500">Commodities Details</h3>
                            </div>
                        </div> 
                        <div className="px-3">
                            {/* All Subaccounts Listed */}
                            {subac.length > 0 && subac.map((currentSubac, subacIndex) => (
                                <div key={currentSubac.subac_id} className="px-1 py-3 border-b border-gray-200">
                                    {/* Asset Name Header */}
                                    <div className="flex items-center">
                                        <p className="text-base text-gray-600 m-0">Asset Name : {currentSubac.commodity_asset_name || currentSubac.subac_name}</p>
                                    </div>

                                    {/* Column Headers */}
                                    <div className="grid grid-cols-3 px-3 mt-3">
                                        <div className="flex items-center pl-2">
                                            <p className="text-gray-500 text-lg m-0 font-semibold">Details</p>
                                        </div>
                                        <div className="flex items-center pl-2">
                                            <p className="text-gray-500 text-lg m-0 font-semibold">Seller</p>
                                        </div>
                                        <div className="flex items-center pl-2">
                                            <p className="text-gray-500 text-lg m-0 font-semibold">Buyer</p>
                                        </div>
                                    </div>

                                    {/* Three Column Layout for this subaccount */}
                                    <div className="grid grid-cols-3 mt-2">
                                        {/* Details Column */}
                                        <div className="border-r border-gray-200 px-1 overflow-y-auto" style={{ maxHeight: '230px' }}>
                                            <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                Date Listed {currentSubac.commodity_detail_date ? moment(currentSubac.commodity_detail_date).format('DD MMM, YYYY') : 'N/A'}
                                            </div>
                                            <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                Ref #{currentSubac.commodity_detail_no || 'N/A'}
                                            </div>
                                            <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                Loading Port <span className="float-right">{currentSubac.commodity_detail_loading_port || 'N/A'}</span>
                                            </div>
                                            <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                Discharge Port <span className="float-right">{currentSubac.commodity_detail_discharge_port || 'N/A'}</span>
                                            </div>
                                            <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                Asset Valuation <span className="text-xs float-right">{currentSubac.currency_symbol}{currentSubac.commodity_asset_valuation?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}</span>
                                            </div>
                                            <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                Net Trade <span className="text-xs float-right">{currentSubac.currency_symbol}{currentSubac.commodity_detail_net_trade?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}</span>
                                            </div>
                                        </div>

                                        {/* Seller Column */}
                                        <div className="border-r border-gray-200 px-1 overflow-y-auto" style={{ maxHeight: '230px' }}>
                                            <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                {currentSubac.commodity_seller_exist === 1 ? (
                                                    <div>
                                                        <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                            Seller: {currentSubac.commodity_seller_name || 'N/A'}
                                                        </div>
                                                        <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                            Date: {currentSubac.commodity_seller_date ? moment(currentSubac.commodity_seller_date).format('DD MMM, YYYY') : 'N/A'}
                                                        </div>
                                                        <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                            Units: {currentSubac.commodity_selling_unit || '0'}
                                                        </div>
                                                        <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                            Rate: {currentSubac.currency_symbol}{currentSubac.commodity_selling_sale_rate?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}
                                                        </div>
                                                        <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                            Price: {currentSubac.currency_symbol}{currentSubac.commodity_selling_price?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    'No Seller Found'
                                                )}
                                            </div>
                                        </div>

                                        {/* Buyer Column */}
                                        <div className="px-1 overflow-y-auto" style={{ maxHeight: '230px' }}>
                                            <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                {currentSubac.commodity_buyer_exist === 1 ? (
                                                    <div>
                                                        <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                            Buyer: {currentSubac.commodity_buyer_name || 'N/A'}
                                                        </div>
                                                        <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                            Date: {currentSubac.commodity_buyer_date ? moment(currentSubac.commodity_buyer_date).format('DD MMM, YYYY') : 'N/A'}
                                                        </div>
                                                        <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                            Units: {currentSubac.commodity_buyer_unit || '0'}
                                                        </div>
                                                        <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                            Rate: {currentSubac.currency_symbol}{currentSubac.commodity_buyer_sale_rate?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}
                                                        </div>
                                                        <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                            Price: {currentSubac.currency_symbol}{currentSubac.commodity_buyer_selling_price?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}
                                                        </div>
                                                        <div className="text-gray-600 border-b border-gray-200 text-sm p-1">
                                                            Deposit: {currentSubac.currency_symbol}{currentSubac.commodity_buyer_deposit?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) || '0.00'}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    'No Buyer Found'
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div> 

                         
                    </div>

                    </div>
                </div>

                {/* Bottom Row - Portfolio and Chart */}
                <div className="flex flex-wrap gap-4 w-full">
                    {/* Bottom Left - Portfolio */}
                    <div className="flex-1 min-w-0" style={{ maxWidth: '33.33%' }}>
                     
                    </div>

                    {/* Bottom Right - Chart */}
                    <div className="flex-1 min-w-0" style={{ maxWidth: '66.67%' }}>
                    <div className="bg-white rounded-xl overflow-hidden h-full">
                        {/* Chart Navigation */}
                        <div className="border-b border-gray-200 px-6 py-4">
                        <div className="flex space-x-8">
                            <button 
                            onClick={() => setActiveChart(1)} 
                            className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                                activeChart === 1 
                                ? 'text-blue-500 border-blue-500' 
                                : 'text-gray-500 border-transparent hover:text-gray-700'
                            }`}
                            >
                            Last Month
                            </button>
                            <button 
                            onClick={() => setActiveChart(2)} 
                            className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                                activeChart === 2 
                                ? 'text-blue-500 border-blue-500' 
                                : 'text-gray-500 border-transparent hover:text-gray-700'
                            }`}
                            >
                            3M
                            </button>
                            <button 
                            onClick={() => setActiveChart(3)} 
                            className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                                activeChart === 3 
                                ? 'text-blue-500 border-blue-500' 
                                : 'text-gray-500 border-transparent hover:text-gray-700'
                            }`}
                            >
                            6M
                            </button>
                            <button 
                            onClick={() => setActiveChart(4)} 
                            className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                                activeChart === 4 
                                ? 'text-blue-500 border-blue-500' 
                                : 'text-gray-500 border-transparent hover:text-gray-700'
                            }`}
                            >
                            Year
                            </button>
                            <button 
                            onClick={() => setActiveChart(5)} 
                            className={`text-sm font-medium py-2 px-1 border-b-2 transition-colors ${
                                activeChart === 5 
                                ? 'text-blue-500 border-blue-500' 
                                : 'text-gray-500 border-transparent hover:text-gray-700'
                            }`}
                            >
                            All
                            </button>
                        </div>
                        </div>

                        {/* Chart Content */}
                        <div className="p-6">
                        {onChart === 1 ? (
                            <div className="h-64 flex items-center justify-center">
                            {activeChart === 1 && (
                                <div className="w-full h-full flex items-center justify-center bg-gray-50 rounded border-2 border-dashed border-gray-300">
                                <span className="text-gray-500">Chart 1 - Last Month</span>
                                </div>
                            )}
                            {activeChart === 2 && (
                                <div className="w-full h-full flex items-center justify-center bg-gray-50 rounded border-2 border-dashed border-gray-300">
                                <span className="text-gray-500">Chart 2 - 3 Months</span>
                                </div>
                            )}
                            {activeChart === 3 && (
                                <div className="w-full h-full flex items-center justify-center bg-gray-50 rounded border-2 border-dashed border-gray-300">
                                <span className="text-gray-500">Chart 3 - 6 Months</span>
                                </div>
                            )}
                            {activeChart === 4 && (
                                <div className="w-full h-full flex items-center justify-center bg-gray-50 rounded border-2 border-dashed border-gray-300">
                                <span className="text-gray-500">Chart 4 - Year</span>
                                </div>
                            )}
                            {activeChart === 5 && (
                                <div className="w-full h-full flex items-center justify-center bg-gray-50 rounded border-2 border-dashed border-gray-300">
                                <span className="text-gray-500">Chart 5 - All Time</span>
                                </div>
                            )}
                            </div>
                        ) : (
                            <div className="h-64 flex items-center justify-center bg-gray-50 rounded border-2 border-dashed border-gray-300">
                            <span className="text-gray-500">Loading...</span>
                            </div>
                        )}
                        </div>
                    </div>
                    </div>
                </div>
                </section>
            </div>
        </>
    );
};

export default Commodities;
